export default __webpack_public_path__ + "static/media/website-example.4d6a474f.jpg";